import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-product-create-step-wrapper',
    templateUrl: './product-create-step-wrapper.component.html',
    styleUrls: ['./product-create-step-wrapper.component.scss'],
    standalone: false
})
export class ProductCreateStepWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
